function getRatiosFromData(divisionData) {
	const ratios = [];
	if (divisionData.children.length > 0 && divisionData.ratio !== void 0) ratios.push(divisionData.ratio);
	for (const d of divisionData.children) ratios.push(...getRatiosFromData(d));
	return ratios;
}
export { getRatiosFromData };

//# sourceMappingURL=index72.js.map